"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JWTDecoder = exports.signerDecoder = exports.decoder = void 0;
const web3_1 = __importDefault(require("web3"));
const JWTGeneric_1 = require("./JWTGeneric");
exports.decoder = (message, signature) => new web3_1.default().eth.accounts.recover(message, signature).toLowerCase();
const signerFactory = (privateKey) => (data) => new web3_1.default().eth.accounts.sign(data, privateKey).signature;
exports.signerDecoder = (privateKey) => {
    const address = new web3_1.default().eth.accounts.privateKeyToAccount(privateKey).address.toLowerCase();
    const signer = signerFactory(privateKey);
    return { signer, decoder: exports.decoder, address };
};
exports.JWTDecoder = (token) => {
    const decoder = (message, signature) => new web3_1.default().eth.accounts.recover(message, signature);
    return new JWTGeneric_1.JWTGeneric((data) => data, decoder).setToken(token);
};
//# sourceMappingURL=signerAndDecoderFromPrivateKey.js.map